import { Show } from "solid-js"
import { Dialog as Kobalte } from "@kobalte/core/dialog"
import { useI18n } from "../context/i18n"
import { IconButton } from "./icon-button"
import { Tooltip } from "./tooltip"

export interface TextPreviewProps {
  text: string
  filename: string
  /** When provided, a download button is shown in the header. */
  onDownload?: () => void
}

// Read-only preview of a text attachment (e.g. an audio transcript .txt) so the
// user can read it inline without downloading. Shown via the dialog context,
// which supplies the Kobalte Root/Portal/Overlay — this provides the Content.
export function TextPreview(props: TextPreviewProps) {
  const i18n = useI18n()
  return (
    <Kobalte.Content
      data-component="text-preview"
      class="fixed left-1/2 top-1/2 z-50 flex h-[min(78vh,700px)] max-h-[92vh] min-h-[320px] w-[min(92vw,900px)] min-w-[420px] max-w-[96vw] -translate-x-1/2 -translate-y-1/2 resize flex-col gap-3 overflow-hidden rounded-lg border border-border-base bg-surface-raised-base p-4 shadow-lg"
    >
      <div class="flex items-center justify-between gap-3">
        <span class="min-w-0 flex-1 truncate text-14-medium text-text-strong" title={props.filename}>
          {props.filename}
        </span>
        <div class="flex shrink-0 items-center gap-1">
          <Show when={props.onDownload}>
            <Tooltip value={i18n.t("ui.common.download")} placement="bottom">
              <IconButton
                icon="arrow-down-to-line"
                variant="ghost"
                aria-label={i18n.t("ui.common.download")}
                onClick={() => props.onDownload?.()}
              />
            </Tooltip>
          </Show>
          <Kobalte.CloseButton as={IconButton} icon="close" variant="ghost" aria-label={i18n.t("ui.common.close")} />
        </div>
      </div>
      <pre class="min-h-0 flex-1 overflow-auto whitespace-pre-wrap break-words rounded-md border border-border-base bg-surface-base p-3 text-13-regular text-text-primary">
        {props.text}
      </pre>
    </Kobalte.Content>
  )
}
